module.exports = __webpack_public_path__ + "img/shanhu3.40c9fdf1.png";